import React, { useState, useEffect } from "react";
import { Modal, Button, Progress, Icon, Image } from "semantic-ui-react";
import ReactPlayer from "react-player";
import "./OnlineClassView.css";
import { useAuthContext } from "../../../Hooks/useAuthContext";
import classimg from "../../../assets/img/CLASS03.png";
import ReactHtmlParser from "html-react-parser";
const OnlineClassView = ({ posts, onLike, onDelete }) => {
  const { user } = useAuthContext();
  const [openPost, setOpenPost] = useState(null); // Track which post is opened
  const [videoProgress, setVideoProgress] = useState({}); // Store progress for each video
  const [playbackRate, setPlaybackRate] = useState(1); // default normal speed
  // Group posts by subCategory
  const groupedByChapter = {};

  posts.forEach((post) => {
    const chapterName = post.subCategory || "Uncategorized";
    if (!groupedByChapter[chapterName]) {
      groupedByChapter[chapterName] = [];
    }
    groupedByChapter[chapterName].push(post);
  });
  // Whenever posts change, update openPost (if necessary)
  useEffect(() => {
    if (openPost) {
      const updatedPost = posts.find((p) => p._id === openPost._id);
      if (updatedPost) {
        setOpenPost(updatedPost);
      }
    }
  }, [posts]);
  // Define access rules per subCategory
  const subCategoryAccessMap = {
    CLASS2025: (user) => user?.user?.isClassMember || user?.user?.role === 1,
    CLASS012025: (user) => user?.user?.isClassMember || user?.user?.role === 1,

    WILLCLASS2026: (user) => user?.user?.isWillClass || user?.user?.role === 1,
    WILLCLASS20262: (user) =>
      user?.user?.isWillClass2 || user?.user?.role === 1,
    WILLCLASS20263: (user) =>
      user?.user?.isWillClass3 || user?.user?.role === 1,
    WILLCLASS20264: (user) =>
      user?.user?.isWillClass4 || user?.user?.role === 1,
    CLASS2026: (user) => user?.user?.isClass2026 || user?.user?.role === 1,

    // MENTOR2026: (user) => user?.user?.isClassMember4 || user?.user?.role === 1,
  };
  const chapterNameMap = {
    CLASS2025: "KHÓA HỌC TRADING TOÀN DIỆN 2025",
    CLASS012025: "KHÓA HỌC TRADING TOÀN DIỆN FEB/2025",
    WILLCLASS2026: "WILL'S TRADING CLASS FEB/2026",
    WILLCLASS20262: "8 NGÀY ICT & FOOTPRINT & MORE APR/2026",
    WILLCLASS20263: "KHOÁ HỌC TRADING CĂN BẢN ĐẾN NÂNG CAO MAY/2026",
    WILLCLASS20264: "8 NGÀY ICT & FOOTPRINT & MORE JULY/2026",
  };

  return (
    <div className="online-classes-container">
      <Image
        centered
        fluid
        // size="medium"
        rounded
        src={classimg}
        alt="We Win Together"
        // style={{ marginTop: "4px", marginBottom: "4px", height: "45px" }}
      />

      {/* <h2 className="online-class-title">
        <span className="purple-text">BIẾN KIẾN THỨC THÀNH LỢI NHUẬN</span>
      </h2> */}
      {Object.keys(groupedByChapter).map((chapterName) => {
        const accessCheck = subCategoryAccessMap[chapterName];
        if (accessCheck && !accessCheck(user)) return null;

        return (
          <div key={chapterName} className="chapter-container">
            <h3 className="chapter-title">
              📖 {chapterNameMap[chapterName] || chapterName}
            </h3>
            <ul className="topics-list">
              {groupedByChapter[chapterName].map((post) => (
                <li key={post._id} className="topic-item">
                  <span
                    className="topic-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => setOpenPost(post)}
                  >
                    {post.topic}
                    {videoProgress[post._id] >= 100 && (
                      <Icon
                        name="check circle"
                        color="green"
                        style={{ marginLeft: "5px" }}
                      />
                    )}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
      {/* Modal for viewing post */}
      {openPost && (
        <Modal
          open
          size="large"
          scrolling
          onClose={() => setOpenPost(null)}
          closeIcon
          image
        >
          <Modal.Header>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontWeight: "bold", fontSize: "18px" }}>
                    {openPost.topic}
                  </span>
                  {videoProgress[openPost._id] >= 100 && (
                    <Icon
                      name="check circle"
                      color="green"
                      style={{ marginLeft: "8px" }}
                    />
                  )}
                  {user &&
                    (user.user.isAdmin ||
                      user.user._id === openPost.userId) && (
                      <Icon
                        name="trash"
                        color="red"
                        style={{
                          marginLeft: "12px",
                          cursor: "pointer",
                          transition: "transform 0.2s ease",
                        }}
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to delete this post?",
                            )
                          ) {
                            onDelete(openPost._id);
                            setOpenPost(null);
                          }
                        }}
                        onMouseEnter={(e) =>
                          (e.target.style.transform = "scale(1.3)")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.transform = "scale(1)")
                        }
                      />
                    )}
                </div>

                {user && (
                  <div
                    onClick={() => onLike(openPost._id)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                  >
                    <Icon
                      name="heart"
                      size="large"
                      color={
                        openPost.like?.includes(user.user._id) ? "red" : "grey"
                      }
                      style={{ transition: "transform 0.3s ease" }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "scale(1.2)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    />
                    <span style={{ marginLeft: "5px", fontSize: "14px" }}>
                      {openPost.like?.length || 0}
                    </span>
                  </div>
                )}
              </div>

              {videoProgress[openPost._id] > 0 && (
                <div style={{ marginTop: "8px" }}>
                  <Progress
                    percent={videoProgress[openPost._id]}
                    size="small"
                    color={
                      videoProgress[openPost._id] >= 100 ? "green" : "blue"
                    }
                    progress
                    indicating
                  />
                </div>
              )}
            </div>
          </Modal.Header>

          <Modal.Content scrolling>
            {openPost.description && (
              <div style={{ marginBottom: "15px" }}>{openPost.description}</div>
            )}
            {openPost.youtubeId && (
              <ReactPlayer
                url={openPost.youtubeId}
                controls={true}
                width="100%"
                // height="100%"
              />
            )}
            {openPost.videoUrl && (
              <div style={{ marginBottom: "15px" }}>
                <div
                  style={{
                    marginTop: "10px",
                    position: "relative",
                    paddingBottom: "56.25%",
                    height: 0,
                  }}
                >
                  <div style={{ marginBottom: "10px", textAlign: "right" }}>
                    <select
                      value={playbackRate}
                      onChange={(e) =>
                        setPlaybackRate(parseFloat(e.target.value))
                      }
                      style={{ padding: "5px", borderRadius: "5px" }}
                    >
                      {[0.5, 0.75, 1, 1.25, 1.5, 1.75, 2].map((rate) => (
                        <option key={rate} value={rate}>
                          {rate}x
                        </option>
                      ))}
                    </select>
                  </div>
                  <video
                    key={openPost._id}
                    src={openPost.videoUrl}
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                    onContextMenu={(e) => e.preventDefault()}
                    autoPlay
                    playbackRate={playbackRate}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#000",
                    }}
                    onLoadedMetadata={(e) => {
                      const savedTime = localStorage.getItem(
                        `video-progress-${openPost._id}`,
                      );
                      if (savedTime)
                        e.target.currentTime = parseFloat(savedTime);
                      const duration = e.target.duration;
                      if (savedTime && duration) {
                        const percentage = Math.floor(
                          (parseFloat(savedTime) / duration) * 100,
                        );
                        setVideoProgress((prev) => ({
                          ...prev,
                          [openPost._id]: percentage,
                        }));
                      }
                    }}
                    onTimeUpdate={(e) => {
                      localStorage.setItem(
                        `video-progress-${openPost._id}`,
                        e.target.currentTime,
                      );
                      const duration = e.target.duration;
                      const percentage = Math.floor(
                        (e.target.currentTime / duration) * 100,
                      );
                      setVideoProgress((prev) => ({
                        ...prev,
                        [openPost._id]: percentage,
                      }));
                    }}
                  ></video>
                </div>
              </div>
            )}
            {openPost.body && <>{ReactHtmlParser(openPost.body)}</>}
            {openPost.fileUrl && (
              <div style={{ marginTop: "20px" }}>
                <strong>Slide Bài Học:</strong>
                <div>
                  {openPost.allowDownload ? (
                    <a
                      href={openPost.fileUrl}
                      download
                      // target="_blank"
                      rel="noopener noreferrer"
                    >
                      📚 {openPost.fileName || "View File"}
                    </a>
                  ) : (
                    <a
                      href={openPost.fileUrl}
                      // target="_blank"
                      rel="noopener noreferrer"
                    >
                      📚 {openPost.fileName || "View File"}
                    </a>
                  )}
                </div>
              </div>
            )}
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};

export default OnlineClassView;
